import React from 'react'
import backgroundVideo1 from '../../../public/images/ART2.mp4'
import backgroundVideo2 from '../../../public/images/dark.mp4'
import backgroundStyle from './styles'

const Background = () => {
  const classes = backgroundStyle()
  return (
    <>
      <div className={classes.noise}></div>
      <div className={classes.video1}>
        <video className={classes.video} muted loop autoPlay plays-inline>
          <source src={backgroundVideo1} type="video/mp4" />
        </video>
      </div>
      <div className={classes.video2}>
        <video className={classes.video} muted loop autoPlay plays-inline>
          <source src={backgroundVideo2} type="video/mp4" />
        </video>
      </div>
    </>
  )
}

export default Background
